import { booleanAttribute, Component, HostBinding, input } from '@angular/core';
import { InputBase } from '../base/input-base';

@Component({
  selector: 'app-input-textarea',
  templateUrl: './input-textarea.component.html',
  styleUrl: './input-textarea.component.scss',
  host: {
    class: 'grid grid-cols-12',
  },
})
export class InputTextareaComponent extends InputBase {
  rows = input(2);
  cols = input(30);
  helperText = input<string>();
  type = input<string>('');
  label = input<string>();
  placeholder = input<string>('');
  fullWidth = input(false, { transform: booleanAttribute });
  autoResize = input(false, { transform: booleanAttribute });
  required = input(false, { transform: booleanAttribute });

  onInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.onChange(value);
    this.value = value;
  }

  writeValue(value: unknown): void {
    this.value = value?.toString() ?? '';
  }

  @HostBinding('class')
  get hostClass() {
    let hostClassName = '';

    if (this.fullWidth()) {
      hostClassName += 'full-width ';
    }

    return hostClassName;
  }
}
